export default "__VITE_PUBLIC_ASSET__32916ac4__"